function isCartPayload(value) {
  return !!value && Array.isArray(value.items) && 'items_subtotal_price' in value;
}

// `knownCart` is the cart that updateFreeShipping() already fetched and sent
// out with the cartUpdate event. Reusing it removes a whole round trip from
// every add / quantity change; we only fetch when nobody handed us one.
async function manageFreeGift(knownCart) {
  if (!window.freeGiftSettings) return;

  const { product: giftVariantId, priceLimit } = window.freeGiftSettings;

  const cart = isCartPayload(knownCart)
    ? knownCart
    : await fetch('/cart.js').then(res => res.json());
  const subtotal = cart.items_subtotal_price;
  const giftItem = cart.items.find(item => item.variant_id === giftVariantId);

  let cartWasChanged = false;

  if (subtotal <= 0 && giftItem) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 0 })
    }).then(res => res.json());
    cartWasChanged = true;
  }

  if (cartWasChanged) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      // Ask the drawer for its own section list rather than reaching for the
      // `sectionsToRender` const in cart-drawer.js. That file is loaded from
      // the cart-drawer snippet, i.e. AFTER this one, so the global is in its
      // temporal dead zone while this script runs - it only works today
      // because the fetch above outlives the rest of the boot sequence.
      const sections = drawer.getSectionsToRender();
      const sectionsResponse = await fetch(
        `${window.location.pathname}?sections=${sections.map(s => s.section).join(',')}`
      ).then(res => res.json());
      sections.forEach(section => {
        const target = document.querySelector(section.id);
        const sectionHTML = sectionsResponse[section.section];

        if (!target || !sectionHTML) return;

        const innerHTML = drawer.getSectionInnerHTML(
          sectionHTML,
          section.selector
        );

        if (innerHTML === null) return;

        target.innerHTML = innerHTML;
      });

      // This repaint never goes through renderContents()/open(), so nothing
      // else puts the iOS scroll lock back in step with the new markup. On
      // iPhone that left the drawer unscrollable after the gift was pulled.
      if (typeof drawer.syncBodyScroll === 'function') drawer.syncBodyScroll();
    }
  }
}

manageFreeGift();

document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
    manageFreeGift(data && data.cartData);
  });
});


